(function () {
    'use strict';

    angular.module("imApp").factory("stockTransfersService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1056,
                    parameters: parms || {}
                });
            },
            listStockTransfers: function (parms) {
                return $ihttp.post({
                    method: 1057,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
